import React, { useState } from 'react';
import { Box, Grid } from '@mui/material';
import {
  MarketButton,
  MarketField,
  MarketInputText,
  MarketBanner,
} from '@market/react';
import sqFetch from 'application/fetch';
import { onCheckoutPageClick } from 'components/pages/checkout/utilities';
import { COMPONENT_NAMES } from 'constants/tracking';
import { useOrderDetails } from 'components/context/order_details';

const SmsSignup = (props) => {
  const {
    orderNumber,
    buttonText,
    validationRegex,
    initialValue,
    validationFailedMessage,
    placeholder,
    header,
    description,
    url,
    successMessage,
    failedMessage,
    disclaimer,
    retry,
  } = props;

  const [value, setValue] = useState(initialValue);
  const [isValid, setIsValid] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmittedSuccessfully, setIsSubmittedSuccessfully] = useState(false);
  const { trackingData } = useOrderDetails();

  const onSubmit = () => {
    const regex = new RegExp(validationRegex);

    if (!regex.test(value)) {
      setIsValid(false);
      return;
    }

    setIsSubmitting(true);
    setIsValid(true);

    sqFetch
      .post(url, {
        order_number: orderNumber,
        phone_number: value,
      })
      .then((response) => {
        setIsSubmitted(true);
        setIsSubmittedSuccessfully(response.ok);
      })
      .catch(() => setIsSubmitted(true))
      .finally(() => setIsSubmitting(false));
  };

  const banner = () => {
    return (
      <MarketBanner variant={isSubmittedSuccessfully ? 'success' : 'critical'}>
        {isSubmittedSuccessfully ? (
          successMessage
        ) : (
          <>
            {failedMessage}
            <button slot="action" onClick={() => setIsSubmitted(false)}>
              {retry}
            </button>
          </>
        )}
      </MarketBanner>
    );
  };

  const form = () => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          <MarketField
            {...(isSubmitting && { disabled: true })}
            {...(!isValid && { invalid: true })}
          >
            <MarketInputText
              value={value}
              placeholder={placeholder}
              onMarketInputValueChange={(e) => setValue(e.detail.value)}
              style={{ height: '48px' }}
            />
            <small slot="error">{!isValid && validationFailedMessage}</small>
          </MarketField>
        </Grid>
        <Grid item xs={12} md={4}>
          <MarketButton
            {...(isSubmitting && { disabled: true })}
            id="sms-signup-btn"
            rank="primary"
            onClick={() => {
              onSubmit();
              onCheckoutPageClick({
                eventDesc: 'Click sign up for sms notifications',
                additionalDetails: {
                  orderNumber,
                  buttonText,
                },
                componentName: COMPONENT_NAMES.APPS.CHECKOUT.ORDER_COMPLETE,
                actionItem: 'get_sms_updates',
                trackingData,
              });
            }}
            style={{ width: '100%' }}
          >
            {buttonText}
          </MarketButton>
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      <Box component="h3" sx={{ mb: 1 }}>
        {header}
      </Box>
      <p>{description}</p>
      {isSubmitted ? banner() : form()}
      <i className="paragraph-10">{disclaimer}</i>
    </>
  );
};

export default SmsSignup;
